import '../../style/index.less';
import './index.less';

// style dependencies
import '../../input/style';
import '../../time-picker/style';
import '../../tag/style';
